import React from 'react';
import {useSelector} from "react-redux";
import {getObject} from "../../hooks/getObject";

const TableSingle = () => {

    const {data_about_users} = useSelector(state => state.main)

    return (
        <div className={'flex flex-wrap mt-8 justify-around mx-4'}>
            {data_about_users.map((data, index) => (
                <div key={index + 1} className={'border border-black w-full p-4 bg-orange-300 md:w-5/12 mt-4'}>
                    <div className={'w-10 h-10 bg-white text-center relative rounded-full text-2xl'}><span className={'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'}>{index + 1}</span></div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Название:</span> {data.NAME}</div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Дата</span>: <strong>{data.PROPERTY_338_VALUE}</strong></div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Имя клиента:</span> {(data.PROPERTY_340) ? getObject(data.PROPERTY_340) : 'Не указано'}</div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Комментарий:</span> {(data.PROPERTY_334) ? getObject(data.PROPERTY_334) : "Не указан"}</div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Телефон:</span> {(data.PROPERTY_332) ? getObject(data.PROPERTY_332) : 'Не указан'}</div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Статус:</span> {(data.PROPERTY_336) ? getObject(data.PROPERTY_336) : 'Не указан'}</div>
                    <div className={'text-xl mt-2 font'}><span className={'font-bold'}>Адрес:</span> {(data.PROPERTY_330) ? getObject(data.PROPERTY_330) : 'Не указан'}</div>
                </div>
            ))}
        </div>
    );
};

export default TableSingle;